import React, { useState, useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { connect } from 'react-redux';
import { systemAPI } from '../../../../apis';
import { AddRolePop, EditRolePop } from '../Pops';
import Results from '../Results';
import { RoleTable } from '../Table';
import { RoleToolBar } from '../ToolBar';
import { updateUserRoleAction } from '../../../../redux/actions/userRole';
import { LOGIN_INFO } from '../../../../comm/constant';
import { userRoleFunc } from '../../../../utils/userRole';
import { rewriteSettingRequestParams } from '../../../../utils/check';

const useStyles = makeStyles((theme) => ({
  results: {
    padding: '1.875rem',
  },
}));
function Role({ loginInfo, userRole, updateUserRole, rouList, roleMap }) {
  const classes = useStyles();

  // WardToolBar
  const [isAddPop, setIsAddPop] = useState(false);
  const closeAddPop = () => {
    setIsAddPop(false);
  };

  // WardTable
  const [RoleList, setRoleList] = useState([]);
  const getSysRoleList = async () => {
    try {
      const { result } = await systemAPI.getSysRoleList(rewriteSettingRequestParams());
      setRoleList(result.data);
    } catch (error) {
      setRoleList([]);
      console.log('------Role error------', error);
    }
  };

  const getSysUserRole = async () => {
    const localLogin = JSON.parse(localStorage.getItem(LOGIN_INFO));
    const { result } = await systemAPI.getSysUserRole({ corpId: localLogin.corpID });
    updateUserRole(result);
  };

  useEffect(() => {
    if (loginInfo.flag) {
      (async () => {
        await getSysRoleList();
      })();
    }
  }, [rouList]);

  const addClick = () => {
    setIsAddPop(true);
  };

  const [isEditPop, setEditPop] = useState(false);
  const [EditItemData, setEditItemData] = useState(null);
  const editClick = (item, index) => {
    setEditPop(true);
    setEditItemData(item);
  };

  // input
  const [inputValues, setInputValues] = useState(null);
  const updatePerMissionIds = (permissionIds) => {
    setInputValues({
      permissionIds,
      roleId: EditItemData.roleId,
      roleName: EditItemData.roleName,
      roleTypeId: EditItemData.roleTypeId,
    });
  };

  const closeEditPop = async () => {
    try {
      if (inputValues) {
        await systemAPI.updateSysRole(inputValues);
        await getSysRoleList();
        if (
          userRole.find((item) => {
            return userRoleFunc.getRoleType(item) === inputValues.roleType;
          })
        ) {
          await getSysUserRole();
        }
      }
    } catch (error) {
      console.log('-----error-----', error);
    }
    setEditPop(false);
  };

  // pops
  const addPopConfirmClick = async (data) => {
    try {
      await systemAPI.createSysRole(data);
      await getSysRoleList();
    } catch (error) {
      console.log('------Role error------', error);
    }
    closeAddPop();
  };

  const editPopConfirmClick = () => {
    return null;
  };

  const [keyword, setKeyword] = useState('');
  const ShowDATA = useMemo(() => {
    let searchRes = [];
    if (keyword === '' || keyword === null || keyword === undefined) {
      searchRes = RoleList;
    } else {
      searchRes = _.filter(RoleList, (o) => {
        return o.roleName.toLowerCase().indexOf(keyword.toLowerCase()) > -1;
      });
    }
    return searchRes;
  }, [RoleList, keyword]);

  return (
    <>
      <RoleToolBar
        addClick={addClick}
        searchClick={(val) => {
          setKeyword(val);
        }}
        onChange={_.debounce((val) => {
          setKeyword(val);
        }, 500)}
        roleMap={roleMap}
      />
      <Results length={ShowDATA ? ShowDATA.length : 0} className={classes.results} />
      <RoleTable editClick={editClick} allData={ShowDATA} />
      {isAddPop ? <AddRolePop open={isAddPop} closePop={closeAddPop} confirmClick={addPopConfirmClick} /> : null}
      {isEditPop ? (
        <EditRolePop
          open={isEditPop}
          closePop={closeEditPop}
          confirmClick={editPopConfirmClick}
          allData={EditItemData}
          updatePerMissionIds={updatePerMissionIds}
        />
      ) : null}
    </>
  );
}

export default connect(
  (state) => ({
    userRole: state.userRole,
    loginInfo: state.loginInfo,
    rouList: state.rouList,
    roleMap: state.roleMap,
  }),
  {
    updateUserRole: updateUserRoleAction,
  }
)(Role);
